export default __webpack_public_path__ + "static/media/step-bg.ec2ff9bd.png";